import { observer } from 'mobx-react';
import styled from 'styled-components';

// Components
import { Alert, Container, Modal } from 'top-component-library';

// constants
import breakpoints from 'constants/breakpoints';
import { header } from 'constants/style';

// hooks
import { useStores } from 'hooks/use-stores';

function ReaderDisconnectedModal() {
  const { stripeTerminalStore } = useStores();
  return (
    <ReaderDisconnectedModal.Modal
      backdropClassName="modal-dark-backdrop"
      centered
      closable={false}
      footer={null}
      onCancel={null}
      visible
      width={650}
    >
      <ReaderDisconnectedModal.Container>
        <ReaderDisconnectedModal.Header>
          <ReaderDisconnectedModal.Title>Ordering Unavailable</ReaderDisconnectedModal.Title>
          <ReaderDisconnectedModal.Description>Card reader is disconnected</ReaderDisconnectedModal.Description>
        </ReaderDisconnectedModal.Header>
        <ReaderDisconnectedModal.Content>
          <ReaderDisconnectedModal.Instructions>
            Please contact a member of the staff to assist you.
            <br /> We apologize for the inconvenience.
          </ReaderDisconnectedModal.Instructions>
          <ReaderDisconnectedModal.Error>
            {stripeTerminalStore.connectionError && (
              <>
                <Alert message={stripeTerminalStore.connectionError.message} type="error" showIcon />
                {stripeTerminalStore.connectionError.availableReaders?.map((reader) => (
                  <span key={reader}>{reader.id}</span>
                ))}
              </>
            )}
          </ReaderDisconnectedModal.Error>
        </ReaderDisconnectedModal.Content>
      </ReaderDisconnectedModal.Container>
    </ReaderDisconnectedModal.Modal>
  );
}

ReaderDisconnectedModal.Modal = styled(Modal)`
  .ant-modal-body {
    padding: 1.5rem;
  }

  .ant-modal-content {
    border-radius: var(--border-radius__small);
  }
`;

ReaderDisconnectedModal.Container = styled(Container)`
  margin-top: ${header.mobile.height}px;

  @media (min-width: ${breakpoints.md}px) {
    margin-bottom: 2rem;
    margin-top: 0;
    max-width: 60rem;
    padding: 1.5rem 2rem 0;
  }
`;

ReaderDisconnectedModal.Header = styled.div`
  margin-bottom: 1rem;
  text-align: center;
`;

ReaderDisconnectedModal.Title = styled.h1`
  margin-bottom: 2px;
  text-transform: uppercase;
  text-align: center;
`;

ReaderDisconnectedModal.Content = styled.div``;

ReaderDisconnectedModal.Description = styled.h4`
  margin-bottom: 2rem;
  margin-top: 0rem;
  text-align: center;
`;

ReaderDisconnectedModal.Instructions = styled.p`
  text-align: center;
  font-size: 20px;
  font-style: italic;
`;

ReaderDisconnectedModal.Error = styled.p`
  align-items: center;
  font-size: 0.75rem;
  letter-spacing: 1px;
  text-transform: initial;
  text-align: center;
  margin-top: 1rem;

  @media (min-width: ${breakpoints.md}px) {
    font-size: 0.875rem;
    margin: 0;
    width: initial;
  }
`;

export default observer(ReaderDisconnectedModal);
